import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import QRCodeScanner from "../components/QRCodeScanner";
import QRCodeGenerator from "../components/QRCodeGenerator";
import QRCodeUploader from "../components/QRCodeUploader";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Modal, Spin } from "antd";
import { FiBell, FiClock, FiMapPin, FiMenu, FiPlus, FiSmartphone } from "react-icons/fi";
import { toast } from "react-toastify";
import userImg from "../image/userImg.png";
import "./Main.css";
import { Dashboard } from "../components/Dashboard";
import CreateContentForm from "../components/Content";
import { CurrentContent } from "../components/CurrentContent";
import UserHowItWorks from "../components/UserHowItWorks";
import { BaseUrl } from "../shared/BaseUrl";
import ProfilePage from "./ProfilePage";
import MyGallery from "../components/MyGallery";

const MOBILE_BREAKPOINT = 1002;

const Main = () => {
  const [scannedData, setScannedData] = useState("");
  const [selectedMenuItem, setSelectedMenuItem] = useState("HowItWorksGuide");
  const [isMobileView, setIsMobileView] = useState(() => {
    if (typeof window === "undefined") {
      return false;
    }
    return window.innerWidth <= MOBILE_BREAKPOINT;
  });
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
  const [notificationsLoading, setNotificationsLoading] = useState(false);
  const [scanNotifications, setScanNotifications] = useState([]);
  const [unreadScanCount, setUnreadScanCount] = useState(0);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const userId = searchParams.get("un");
  // const token = localStorage.getItem("token");
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const tokenn = query.get("token");
  if (tokenn) {
    localStorage.setItem("token", tokenn);
  }
  const token = localStorage.getItem("token");
  
  const username = localStorage.getItem("username");

  const getApiErrorMessage = (error, fallbackMessage) => {
    return (
      error?.response?.data?.message ||
      error?.message ||
      fallbackMessage
    );
  };

  const fetchScanSummary = async () => {
    if (!token || token === "null" || token === "undefined") {
      return;
    }
    try {
      const response = await axios.get(`${BaseUrl}/api/content/scans/summary`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const summary = response?.data?.summary || {};
      setUnreadScanCount(Number(summary.unreadNotifications || 0));
    } catch (error) {
      // Non-blocking for shell rendering.
    }
  };

  const fetchScanNotifications = async () => {
    if (!token || token === "null" || token === "undefined") {
      return;
    }
    setNotificationsLoading(true);
    try {
      const response = await axios.get(
        `${BaseUrl}/api/content/scans/notifications?limit=30`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setScanNotifications(response?.data?.notifications || []);
      setUnreadScanCount(Number(response?.data?.unreadNotifications || 0));
    } catch (error) {
      toast.error(
        getApiErrorMessage(error, "Unable to load scan notifications."),
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    } finally {
      setNotificationsLoading(false);
    }
  };

  const markNotificationsRead = async () => {
    if (!token || token === "null" || token === "undefined") {
      return;
    }
    try {
      await axios.post(
        `${BaseUrl}/api/content/scans/notifications/read`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setUnreadScanCount(0);
      setScanNotifications((prev) =>
        prev.map((item) => ({
          ...item,
          isRead: true,
        }))
      );
    } catch (error) {
      // Keep UX non-blocking.
    }
  };

  const handleOpenNotifications = async () => {
    setIsNotificationsOpen(true);
    await fetchScanNotifications();
    await markNotificationsRead();
  };

  const formatScanTime = (value) => {
    if (!value) {
      return "Unknown time";
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return "Unknown time";
    }
    return date.toLocaleString();
  };

  const formatLocationText = (item) => {
    const location = item?.location || {};
    const parts = [location.city, location.region, location.country].filter(Boolean);
    if (parts.length > 0) {
      return parts.join(", ");
    }
    if (location.timezone) {
      return location.timezone;
    }
    return "Location unavailable";
  };

  const formatDeviceText = (item) => {
    const device = item?.device || {};
    const parts = [device.deviceType, device.browser, device.os].filter(Boolean);
    return parts.length > 0 ? parts.join(" | ") : "Device unavailable";
  };

  // useEffect(() => {
  //   setSelectedMenuItem(userId ? "CurrentContent" : "Generator");
  // }, [userId]);
  useEffect(() => {
    const checkUserQR = async () => {
      if (userId) {
        setSelectedMenuItem("CurrentContent");
      } else {
        try {
          console.log("token is", token);
          
          const response = await axios.get(`${BaseUrl}/api/qrcode/user/qr`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (response.data && response.data._id) {
            setSelectedMenuItem("CurrentContent");
          } else {
            setSelectedMenuItem("HowItWorksGuide");
          }
        } catch (error) {
          console.error("Error checking user QR:", error);
          if (error?.response?.status === 400 || error?.response?.status === 404) {
            setSelectedMenuItem("HowItWorksGuide");
          } else if (error?.response?.status === 401) {
            if (token) {
              toast.error("Your session has expired. Please log in again.", {
                position: "top-right",
                autoClose: 3000,
              });
            }
            setSelectedMenuItem("Generator");
          } else {
            toast.error(
              getApiErrorMessage(error, "Unable to load QR status right now."),
              {
                position: "top-right",
                autoClose: 3000,
              }
            );
            setSelectedMenuItem("Generator");
          }
        }
      }
    };

    checkUserQR();
  }, [userId, token]);

  useEffect(() => {
    if (userId) {
      return;
    }
    fetchScanSummary();
    const intervalId = setInterval(() => {
      fetchScanSummary();
    }, 45000);
    return () => clearInterval(intervalId);
  }, [userId, token]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (!isMobileView) {
      setIsMobileSidebarOpen(false);
    }
  }, [isMobileView]);

  useEffect(() => {
    if (!isMobileSidebarOpen) {
      return undefined;
    }
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsMobileSidebarOpen(false);
      }
    };
    window.addEventListener("keydown", handleEscape);
    return () => {
      window.removeEventListener("keydown", handleEscape);
    };
  }, [isMobileSidebarOpen]);

  const handleScan = async (data) => {
    console.log({ data });
    setScannedData(data.text);
    try {
      const response = await axios.get(`/api/qrcode/${data}`);
      console.log("Scanned data:", response.data);
    } catch (error) {
      console.error("Error fetching scanned data", error);
      toast.error(
        getApiErrorMessage(error, "Unable to fetch scanned QR details."),
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    }
  };

  const handleMenuItemClick = (menuItem) => {
    setSelectedMenuItem(menuItem);
    setScannedData(""); // Reset scanned data when a menu item is clicked
    if (isMobileView) {
      setIsMobileSidebarOpen(false);
    }
  };

  const handleUploadScan = async (data) => {
    setScannedData(data);
    try {
      const response = await axios.get(`/api/qrcode/${data}`);
      console.log("Scanned data:", response.data);
    } catch (error) {
      console.error("Error fetching scanned data", error);
      toast.error(
        getApiErrorMessage(error, "Unable to fetch uploaded QR details."),
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    }
  };

  // Render only CurrentContent if userId is present
  if (userId) {
    return <CurrentContent />;
  }

  const activeView = selectedMenuItem || "Scanner";
  const welcomeName = username || "Creator";
  const viewTitles = {
    Dashboard: "Home",
    CurrentContent: "Current Content",
    Scanner: "Scanner",
    Generator: "Generator",
    Content: "Create Content",
    AddToGallery: "Add To Gallery",
    MyGallery: "My Gallery",
    HowItWorksGuide: "How It Works",
    Profile: "Profile",
    Uploader: "Uploader",
  };

  return (
    <div className="main-app-container">
      <div className="content-container">
        <Sidebar
          onMenuItemClick={handleMenuItemClick}
          activeMenuItem={activeView}
          isMobileView={isMobileView}
          isMobileOpen={isMobileSidebarOpen}
          onRequestCloseMobile={() => setIsMobileSidebarOpen(false)}
        />
        {isMobileView && isMobileSidebarOpen && (
          <button
            type="button"
            className="main-mobile-overlay"
            aria-label="Close menu"
            onClick={() => setIsMobileSidebarOpen(false)}
          />
        )}
        <main className="main-content">
          <header className="main-shell-header">
            <div className="main-shell-welcome">
              <img src={userImg} alt="User avatar" />
              <div>
                <h1>Welcome back, {welcomeName}</h1>
                <p>
                  Manage your QR code, upload content, track performance and create new
                  experiences.
                </p>
              </div>
            </div>
            <div className="main-shell-actions">
              {isMobileView && (
                <button
                  type="button"
                  className="main-menu-btn"
                  onClick={() => setIsMobileSidebarOpen(true)}
                  aria-label="Open menu"
                >
                  <FiMenu />
                </button>
              )}
              <button
                type="button"
                className="main-create-btn"
                onClick={() => setSelectedMenuItem("Content")}
              >
                <FiPlus />
                Upload Content
              </button>
              <button
                type="button"
                className="main-notify-btn"
                aria-label="Notifications"
                onClick={handleOpenNotifications}
              >
                <FiBell />
                {unreadScanCount > 0 && (
                  <span className="main-notify-dot">
                    {unreadScanCount > 99 ? "99+" : unreadScanCount}
                  </span>
                )}
              </button>
            </div>
          </header>

          {activeView !== "Dashboard" && activeView !== "MyGallery" && (
            <h2 className="main-heading">{viewTitles[activeView]}</h2>
          )}

          {(selectedMenuItem === "Scanner" || selectedMenuItem === "") && (
            <>
              <QRCodeScanner onScan={handleScan} />
              {scannedData && (
                <div className="main-scanned-preview">
                  <b>Scanned Content</b>
                  <p>{scannedData}</p>
                </div>
              )}
            </>
          )}
          {selectedMenuItem === "Generator" && (
            <>
              <QRCodeGenerator />
            </>
          )}
          {selectedMenuItem === "Uploader" && (
            <>
              <QRCodeUploader onScan={handleUploadScan} />
              {scannedData && (
                <div className="main-scanned-preview">
                  <b>Uploaded QR Code Data</b>
                  <p>{scannedData}</p>
                </div>
              )}
            </>
          )}
          {selectedMenuItem === "Dashboard" && <Dashboard />}
          {selectedMenuItem === "CurrentContent" && <CurrentContent />}
          {selectedMenuItem === "Content" && (
            <CreateContentForm
              onContentCreated={() => {
                setSelectedMenuItem("CurrentContent");
              }}
            />
          )}
          {selectedMenuItem === "AddToGallery" && (
            <CreateContentForm
              uploadMode="gallery"
              onContentCreated={() => {
                setSelectedMenuItem("MyGallery");
              }}
            />
          )}
          {selectedMenuItem === "MyGallery" && <MyGallery />}
          {selectedMenuItem === "HowItWorksGuide" && <UserHowItWorks />}
          {selectedMenuItem === "Profile" && <ProfilePage />}
        </main>
      </div>
      <Modal
        title="Scan Notifications"
        open={isNotificationsOpen}
        onCancel={() => setIsNotificationsOpen(false)}
        footer={null}
        width={760}
      >
        {notificationsLoading ? (
          <div className="main-notifications-loading">
            <Spin tip="Loading notifications..." />
          </div>
        ) : scanNotifications.length === 0 ? (
          <div className="main-notifications-empty">
            No scans yet. Notifications will appear here when someone opens your QR.
          </div>
        ) : (
          <div className="main-notifications-list">
            {scanNotifications.map((item) => (
              <article
                key={item._id}
                className={`main-notification-card ${item.isUniqueVisitor ? "unique" : ""}`}
              >
                <div className="main-notification-row">
                  <span className="main-notification-title">
                    {item.isUniqueVisitor ? "New unique visitor" : "Returning visitor scan"}
                  </span>
                  <span className="main-notification-time">
                    <FiClock />
                    {formatScanTime(item.scannedAt)}
                  </span>
                </div>
                <div className="main-notification-row muted">
                  <span>
                    <FiMapPin />
                    {formatLocationText(item)}
                  </span>
                  <span>
                    <FiSmartphone />
                    {formatDeviceText(item)}
                  </span>
                </div>
              </article>
            ))}
          </div>
        )}
      </Modal>
    </div>
  );
};

export default Main;
